import { addDays, set } from 'date-fns';

export const INIT_DATE_TIME = {
  pickUpDate: addDays(new Date(), 1),
  pickUpTime: set(new Date(), { hours: 10, minutes: 0 }),
  dropOffDate: addDays(new Date(), 4),
  dropOffTime: set(new Date(), { hours: 10, minutes: 0 }),
  driversAge: 35
}
